// extracted by mini-css-extract-plugin
export var aircallIframe = "_jo-3";
export var fabContainer = "_jo-5";
export var fabRinging = "_jo-6";
export var loadingOverlay = "_jo-4";
export var pulse = "_jo-7";
export var widgetContent = "_jo-2";
export var widgetPanel = "_jo-0";
export var widgetPanelExpanded = "_jo-1";